import axios from 'axios';

import authToken from './authToken';
import { uploadImage, deleteImage } from 'js/library/services/StorageManager.js';
import { b64toBlob } from 'js/library/utils/helpers';
import cfac22 from '../cfac22';

export function updateOrg(
  orgId,
  newInfo,
  newCoverImage,
  coverImageFile,
  oldCoverImage,
  newThumbnail,
  thumbnailFile,
  oldThumbnail,
  logoImageFile,
  newLogo,
  oldLogoImage
) {
  return new Promise((resolve, reject) => {
    authToken()
      .then((token) => {
        //console.log('RESULTADO AUTH ===>', result);

        const axiosConfig = {
          method: 'post',
          url:
            cfac22('API_HOST_V2') +
            (orgId
              ? '/organizations/insertOrUpdateOrg?orgId=' + orgId
              : '/organizations/insertOrUpdateOrg'),
          headers: {
            authorization: 'Bearer ' + token,
            'Full-Url': window.location.href,
          },
          data: {
            ...newInfo,
          },
        };

        axios(axiosConfig)
          .then(async (result) => {
            const promises = [];

            if (newThumbnail) {
              const splitedOldThumbnail = oldThumbnail && oldThumbnail.split('/');
              if (oldThumbnail) {
                promises.push(deleteImage(splitedOldThumbnail[0], splitedOldThumbnail[1]));
              }
              promises.push(
                uploadImage(
                  'organizations',
                  b64toBlob(thumbnailFile),
                  newInfo.thumbnail.split('/')[1]
                )
              );
            }

            if (newCoverImage) {
              const splitedOldCoverImageData = oldCoverImage && oldCoverImage.split('/');
              if (oldCoverImage) {
                promises.push(
                  deleteImage(splitedOldCoverImageData[0], splitedOldCoverImageData[1])
                );
              }
              promises.push(
                uploadImage(
                  'organizations',
                  b64toBlob(coverImageFile),
                  newInfo.coverImage.split('/')[1]
                )
              );
            }

            if (newLogo) {
              const splitedOldLogoImage = oldLogoImage && oldLogoImage.split('/');
              if (oldLogoImage) {
                promises.push(deleteImage(splitedOldLogoImage[0], splitedOldLogoImage[1]));
              }
              promises.push(
                uploadImage(
                  'organizations',
                  b64toBlob(logoImageFile),
                  newInfo.logoImage.split('/')[1]
                )
              );
            }

            await Promise.all(promises);

            resolve(result.data);
          })
          .catch((error) => {
            // console.log("ERROR UPDATE ORG ---->", error);
            reject(error);
          });
      })
      .catch((error) => {
        // console.log("ERROR GET CHANNEL TOKEN ---->", error);
        reject(error);
      });
  });
}
